module.exports = __webpack_public_path__ + "static/media/aboutImg0.87b8a16f.webp";